import React from 'react';
import ReactDOM from 'react-dom/client';
import SiteDesignGraphique from './graphic';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SiteDesignGraphique />
  </React.StrictMode>
);